import * as React from "react";
import axios from 'axios';
import { useSelector, useDispatch } from "react-redux";
import dayjs from 'dayjs';
import { seteventdetail, cleareventdetail } from "../features/CreateEventDetailSlice";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { TimePicker } from 'rsuite';
import { DateTime } from "luxon";
import { variables } from '../Variables';

import { DateRangePicker } from 'react-date-range';
import { enGB, fr, nl } from 'date-fns/locale';
import { format } from 'date-fns';
import { defaultStaticRanges, defaultInputRanges } from "react-date-range/dist/defaultRanges";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import "rsuite/dist/rsuite.min.css";

import plusBlueIcon from '../assets/images/plus_blue.svg';
import trashIcon from '../assets/images/trash.svg';
import closeIcon from '../assets/images/cross-close.svg';
import warning from '../assets/images/warning.svg';
import { setBookAbleUntil, clearBookAbleUntil } from "../features/BookAbleUntilSlice";

const { useState, useEffect, useRef } = React;
//const locales = ['en', 'en-gb', 'zh-cn', 'de', 'fr-BE'];

export const AvailableHours = ({ handleClose, callBackClickHandlerNext, backButtonClickHandler }) => {
    const [checkbox, setCheckbox] = useState(false);
    const [startingOnDate, setStartingOnDate] = useState(null);
    const [endingOnDate, setEndingOnDate] = useState(null);
    const [timeSlotsOnAccept, setTimeSlotsOnAccept] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
    const [datesListBetweenStartAndEnd, setDatesListBetweenStartAndEnd] = useState([]);
    const [timeSlotValidationMessage, setTimeSlotValidationMessage] = useState("");
    const [checkIntervalTimeDateSelect, setCheckIntervalTimeDateSelect] = useState(false);

    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxSelectedLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const user = useSelector(state => state.user.user);
    const reduxProperty = useSelector(state => state.selectedProperty.selectedProperty);
    const reduxBookableUntil = useSelector(state => state.bookAbleUntil.bookAbleUntil);
    const reduxScheduleTimeSlotsDetail = useSelector(state => state.scheduleTimeSlotsDetail.scheduleTimeSlotsDetail);

    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

    const [validTill, setValidTill] = useState("");
    const status = useSelector(state => state.statusFilter.statusFilter);
    const agent = useSelector(state => state.agentFilter.agentFilter);
    const reduxEventDetail = useSelector(state => state.eventDetail.eventDetail);
    const userAccountType = useSelector(state => state.userAccountType.userAccountType);

   /* console.log(reduxEventDetail);*/
    const dispatch = useDispatch();
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    // daterangepicker states, object & logics
    const [dateRangePickerState, setDateRangePickerState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef(null);
    const [inputDateRangeLbl, setInputRangeLabels] = useState(null);
    const [staticDateRangeLbl, setStaticDateRangeLbl] = useState(null);
    const [bookAbleUnitVal, setBookAbleUnitVal] = useState("");
    const [bookAbleUnitLbl, setBookAbleUnitLbl] = useState("");
    const [duplicateTimeSlots, setDuplicateTimeSlots] = useState([]);

    const locales = { 'en-GB': enGB, 'fr-BE': fr, 'nl-BE': nl };
    const currentLocale = locales[reduxSelectedLanguage];

    const staticRangesLabels = {
        "Today": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerTodayLbl"] : "Today",
        "Yesterday": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerYesterdayLbl"] : "Yesterday",
        "This Week": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerThisWeekLbl"] : "This Week",
        "Last Week": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerLastWeekLbl"] : "Last Week",
        "This Month": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerThisMonthLbl"] : "This Month",
        "Last Month": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerLastMonthLbl"] : "Last Month"
    };

    const inputRangesLabels = {
        "days up to today": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerdaysUpTodayLbl"] : "days up to today",
        "days starting today": reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerdayStartingLbl"] : "days starting today"
    };

    const keysToRemove = [
        reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerYesterdayLbl"] : "Yesterday",
        reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerLastWeekLbl"] : "Last Week",
        reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerLastMonthLbl"] : "Last Month"
    ];

    const keysRemoveInputRangeLbl = [
        reduxLanguageTranslations ? reduxLanguageTranslations["dateRangePickerdaysUpTodayLbl"] : "days up to today"
    ]

    useEffect(() => {
        if (reduxEventDetail && reduxEventDetail.timeSlots) {
            setTimeSlots(structuredClone(reduxEventDetail.timeSlots));
        }
        if (reduxEventDetail && reduxEventDetail.selectedDateRange) {
            setDateRangePickerState(reduxEventDetail.selectedDateRange);
            setStartingOnDate(new Date(reduxEventDetail.selectedDateRange[0].startDate));
            setEndingOnDate(new Date(reduxEventDetail.selectedDateRange[0].endDate));
        }
    }, [reduxEventDetail])

    function translateRange(dictionary) {
        return (item) =>
            dictionary[item.label] ? { ...item, label: dictionary[item.label] } : item;
    }

    useEffect(() => {

        const ruInputRanges = defaultInputRanges.map(translateRange(inputRangesLabels))
            .filter((range) => !keysRemoveInputRangeLbl.includes(range.label));

        const ruStaticRanges = defaultStaticRanges.map(translateRange(staticRangesLabels))
            .filter((range) => !keysToRemove.includes(range.label));

        setInputRangeLabels(ruInputRanges);
        setStaticDateRangeLbl(ruStaticRanges);

    }, [reduxSelectedLanguage])

    const handlerBookAbleUnitVal = (e) => {
        const value = e.target.value;
        setBookAbleUnitVal(value);
        setTimeSlotValidationMessage("");
    }

    const handlerBookAbleUnitSelectLbl = (e) => {
        const value = e.target.value;
        setBookAbleUnitLbl(value);
        if (value === "") {
            setBookAbleUnitVal("");
        }
    }

    const getEstateConfigurationsFromDb = async () => {

        const url = variables.API_URL + `Calendar/GetEstateConfigurations?clientId=${user.user.clientId}&estateId=${reduxProperty.id}`;

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };

        await axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                let _estateConfig = response.data;
                if (_estateConfig != null && _estateConfig.bookableUntilType && _estateConfig.bookableUntilValue) {
                    console.log(_estateConfig);
                    setBookAbleUnitLbl(_estateConfig.bookableUntilType);
                    setBookAbleUnitVal(_estateConfig.bookableUntilValue);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    // end daterangepicker states, object & logics

    const addNewSlotDurationRow = (e) => {
        var rowData = JSON.parse(e.target.getAttribute("durationitem"));
        let slotDuration = +reduxEventDetail.event.EventDuration;

        if (rowData.isChecked == false) {
            return;
        }
        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day && item.endTimes.length > 0) {

                //get last element of start time and end time of current duration row
                let lastElementEndTimes = item.endTimes[item.endTimes.length - 1];
                let length = item.endTimes.length;

                //convert duration to milliseconds
                let minutesToAdd = slotDuration * 60000;

                //get last row start and end time of current duration row
                item.startTimes.push({ field: item.day + 'From' + length + 1, date: lastElementEndTimes.date });

                //add minutes
                let endDateToSet = new Date(lastElementEndTimes.date);
                endDateToSet.setTime(endDateToSet.getTime() + minutesToAdd);

                //push final element to start and end times arrays of selected duration row
                item.endTimes.push({ field: item.day + 'To' + length + 1, date: endDateToSet });
                item.durationSlotsRows.push(item.durationSlotsRows.length + 1);
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    const deleteSlotRow = (e) => {
        var rowToDelete = JSON.parse(e.target.getAttribute("rownumber"));
        var rowData = JSON.parse(e.target.getAttribute("durationitem"));
        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {
                let indexOfRow = item.durationSlotsRows.indexOf(+rowToDelete);
                item.startTimes.splice(indexOfRow, 1);
                item.endTimes.splice(indexOfRow, 1);
                item.durationSlotsRows.splice(indexOfRow, 1);
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
        /*console.log(updatedTimeSlots);*/
    }

    const enableSelectedDayTimeSlot = (e) => {
        let checkboxValue = e.target.checked;
        var rowData = JSON.parse(e.target.getAttribute("durationitem"));
        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {
                if (checkboxValue == true) {
                    item.isChecked = true;
                }
                else {
                    item.isChecked = false;
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    const setStartTime = (val, hoursItem, Id) => {
        let time = dayjs(val).format("HH:mm");

        var rowData = hoursItem; //JSON.parse(e.target.getAttribute("durationitem"));
        let elementId = rowData.day + "To" + rowData.durationSlotsRows.length;

        if (time != "") {
            document.getElementById(Id).parentNode.removeAttribute("style"); //e.target.removeAttribute("style");
            setTimeSlotValidationMessage("");
        }

        let splittedTime = time.split(":");
        let timeArray = splittedTime.map(item => { return +item });

        let date = new Date();
        var currentDay = date.getDay();
        let currentHour = date.getHours();
        let currentMinutes = date.getMinutes();

        var distance = rowData.weekDay - currentDay;
        if (distance < 0) {
            date.setDate(date.getDate() + distance + 7);
        }
        else {
            date.setDate(date.getDate() + distance);
        }
        date.setHours(timeArray[0]);
        date.setMinutes(timeArray[1]);

        let startDateTime = new Date(date);
        let slotDuration = +reduxEventDetail.event.EventDuration;
        startDateTime.setMinutes(startDateTime.getMinutes() + slotDuration);

        if (startDateTime.getDate() > date.getDate()) {
            document.querySelector("#" + rowData.day + "From" + rowData.durationSlotsRows.length).parentNode.style.borderColor = "red";
            let message = reduxLanguageTranslations ? (reduxLanguageTranslations["invalidStartTimeErrorMessage"] + ": " + slotDuration) : ("Invalid Start Time! because end time will cross midnight time as slot duration is: " + slotDuration);
            setTimeSlotValidationMessage(message);
            //document.querySelector("#" + rowData.day + "From" + rowData.durationSlotsRows.length).value = "";
            //return;
        }

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {

                let indexExist = -1;
                item.startTimes.forEach((item, i) => {
                    if (item.field == Id) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: Id, date: date }
                if (indexExist == -1) {
                    item.startTimes.push(timeObj);
                }
                else {
                    item.startTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
        setEndTime(elementId, date, rowData)
    }

    const setEndTime = (elementId, date, rowData) => {
        document.getElementById(elementId).parentNode.removeAttribute("style");

        let endDate = new Date(date);
        let minutesToAdd = +reduxEventDetail.event.EventDuration
        endDate.setMinutes(endDate.getMinutes() + minutesToAdd);
        let hours = endDate.getHours() < 10 ? "0" + endDate.getHours() : endDate.getHours();
        let minutes = endDate.getMinutes() < 10 ? "0" + endDate.getMinutes() : endDate.getMinutes();
        var time = hours + ":" + minutes;

        //const timePicker = new rsuite.TimePicker(document.getElementById(elementId), {
        //    format: 'HH:mm' // Ensuring 06:00 format
        //});

        //timePicker.updateValue(dayjs(time));

        document.getElementById(elementId).value = time;

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {

                let indexExist = -1;
                item.endTimes.forEach((eTime, i) => {
                    if (eTime.field == elementId) {
                        indexExist = i;
                    }
                })
                let timeObj = { field: elementId, date: endDate }
                if (indexExist == -1) {
                    item.endTimes.push(timeObj);
                }
                else {
                    item.endTimes[indexExist] = timeObj
                }
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    const onChangeHandlerEndTime = (val, entity, elementId) => {
        let value = dayjs(val).format("HH:mm");

        if (value != "") {
            document.getElementById(elementId).parentNode.removeAttribute("style");
        }

        let updatedTimeSlots = timeSlots.map(item => {
            if (entity.day == item.day) {
                if (item.endTimes.length > 0) {
                    item.endTimes.forEach((eTime, i) => {
                        if (eTime.field == elementId) {
                            let splittedTime = value.split(":");
                            eTime.date.setHours(splittedTime[0]);
                            eTime.date.setMinutes(splittedTime[1]);
                        }
                    })
                }
                else {
                    let date = new Date();
                    let splittedTime = value.split(":");
                    date.setHours(splittedTime[0]);
                    date.setMinutes(splittedTime[1]);
                    let timeObj = { field: elementId, date: date }
                    item.endTimes.push(timeObj);
                }
                item.isOkButtonVisible = true;
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);
    }

    const generateSubSlots = (id, item) => {
        setTimeSlotValidationMessage("");
        let endTime = document.getElementById(id).value;
        document.querySelector("#" + item.day + "To1").parentNode.removeAttribute("style");

        let slotDuration = +reduxEventDetail.event.EventDuration;
        var rowData = item;
        let fromElementId = rowData.day + "From" + 1;
        let fromTime = document.getElementById(fromElementId).value;

        if (fromTime == "") {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrMessageSelectStartTime"] : "Select event start time first");
            document.getElementById(id).value = "";
            return;
        }

        let startDateTime = new Date();
        let endDateTime = new Date();

        startDateTime.setHours(fromTime.split(":")[0]);
        startDateTime.setMinutes(fromTime.split(":")[1]);
        endDateTime.setHours(endTime.split(":")[0]);
        endDateTime.setMinutes(endTime.split(":")[1]);

        let startingAtHour = fromTime.split(":")[0];
        let endingAtHour = endTime.split(":")[0];

        let diffMs = endDateTime - startDateTime;
        // Convert the difference to minutes
        let diffMinutes = diffMs / 60000;

        // Get the count of complete slots
        let count = Math.floor(diffMinutes / slotDuration);

        if ((slotDuration == 60 && endingAtHour <= startingAtHour) || (slotDuration < 60 && count < 0)) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrMessageEventEndTimeIncr"] : "Event end time should be greater than start time");
            document.getElementById(id).value = ""; //e.target.value = "";
            document.getElementById(id).parentNode.style.borderColor = "red";
            let updatedTimeSlots = timeSlots.map(item => {
                if (rowData.day == item.day) {
                    let _startTimes = item.startTimes.filter((time, i) => {
                        return i == 0;
                    })
                    return {
                        ...item,
                        startTimes: [..._startTimes],
                        endTimes: [],
                        durationSlotsRows: [1]
                    }
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);
            return;
        }

        //var diffMs = (endDateTime - startDateTime); // milliseconds between start and end date
        //var diffDays = Math.floor(diffMs / 86400000); // days
        //var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
        //var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

        if (slotDuration == 60 && count == 0) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrMessageSlotAddbetween60hr"] : "Please choose a start hour and end hour that can be divide in slot of '60 minutes' or go back and change the selected duration choosen in first screen.");
            //e.target.value = "";
            let updatedTimeSlots = timeSlots.map(item => {
                if (rowData.day == item.day) {
                    let _startTimes = item.startTimes.filter((time, i) => {
                        return i == 0;
                    })
                    return {
                        ...item,
                        startTimes: [..._startTimes],
                        endTimes: [],
                        durationSlotsRows: [1]
                    }
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);
            return;
        }

        if (slotDuration < 60 && count == 0) {
            let messagePart1 = reduxLanguageTranslations ? reduxLanguageTranslations["availableHoursValidationPartOneForDurationLessThan60"] : "Please choose a start hour and end hour that can be divide in slot of";
            let messagePart2 = reduxLanguageTranslations ? reduxLanguageTranslations["availableHoursValidationPartTwoForDurationLessThan60"] : "minutes' or go back and change the selected duration choosen in first screen";
            setTimeSlotValidationMessage(`${messagePart1} '${slotDuration} ${messagePart2}`);
            //e.target.value = "";
            let updatedTimeSlots = timeSlots.map(item => {
                let _startTimes = item.startTimes.filter((time, i) => {
                    return i == 0;
                })
                if (rowData.day == item.day) {
                    return {
                        ...item,
                        startTimes: [..._startTimes],
                        endTimes: [],
                        durationSlotsRows: [1]
                    }
                }
                return item
            })
            setTimeSlots(updatedTimeSlots);
            return;
        }

        //timeSlots.forEach(item => {
        //    if (rowData.day == item.day) {
        //        let firstStartIem = item.startTimes[0];
        //        let firstEndItem = {};
        //        if (item.endTimes.length == 0) {
        //            let timeObj = {};
        //            let endDate = new Date(firstStartIem.date);
        //            let minutesToAdd = slotDuration
        //            endDate.setMinutes(endDate.getMinutes() + minutesToAdd);
        //            timeObj.field = item.day + 'To' + firstStartIem.field.split("From")[1];
        //            timeObj.date = endDate;

        //            firstEndItem = timeObj;
        //        }
        //        else {
        //            firstEndItem = item.endTimes[0];
        //        }

        //        item.startTimes = [];
        //        item.startTimes.push(firstStartIem);
        //        item.endTimes = [];
        //        item.endTimes.push(firstEndItem);
        //        item.durationSlotsRows = [1];
        //    }
        //})

        let hour = "";
        let minutes = "";

        let updatedTimeSlots = timeSlots.map(item => {
            if (rowData.day == item.day) {
                for (var i = 0; i < count; i++) {
                    if (i == 0) {
                        let firstStartTime = item.startTimes[i].date;
                        let firstEndTime = new Date(firstStartTime);
                        firstEndTime.setMinutes(firstEndTime.getMinutes() + slotDuration);

                        item.startTimes = [];
                        item.startTimes.push({ field: item.day + 'From' + (1), date: firstStartTime })

                        item.endTimes = [];
                        item.endTimes.push({ field: item.day + 'To' + (1), date: firstEndTime })

                        item.durationSlotsRows = [];
                        item.durationSlotsRows.push(1);

                        hour = firstEndTime.getHours();
                        minutes = firstEndTime.getMinutes();
                    }
                    else {
                        let startTime = new Date(item.endTimes[i - 1].date);
                        item.startTimes.push({ field: item.day + 'From' + (i + 1), date: startTime })
                        let endTime = new Date(startTime);
                        endTime.setMinutes(endTime.getMinutes() + slotDuration);
                        item.endTimes.push({ field: item.day + 'To' + (i + 1), date: endTime });
                        item.durationSlotsRows.push(item.durationSlotsRows.length + 1);
                    }
                }
                item.isOkButtonVisible = false;
            }
            return item
        })
        setTimeSlots(updatedTimeSlots);

        //if (slotDuration < 60 && isValidEndTime == true) {
        //    let minutesToAdd = slotDuration * 60000;
        //    let updatedTimeSlots = timeSlots.map(item => {
        //        if (rowData.day == item.day) {
        //            for (var i = 0; i < slotsToAdd; i++) {
        //                if (i == 0) {
        //                    let eventEndTime = new Date(item.startTimes[i].date);
        //                    eventEndTime.setTime(eventEndTime.getTime() + minutesToAdd);
        //                    item.endTimes[i].date = eventEndTime;
        //                    hour = eventEndTime.getHours();
        //                    minutes = eventEndTime.getMinutes();
        //                }
        //                else {
        //                    let startTime = new Date(item.endTimes[i - 1].date);
        //                    item.startTimes.push({ field: item.day + 'From' + (i + 1), date: startTime })
        //                    let endTime = new Date(startTime);
        //                    endTime.setTime(endTime.getTime() + minutesToAdd);
        //                    item.endTimes.push({ field: item.day + 'To' + i, date: endTime })
        //                    item.durationSlotsRows.push(item.durationSlotsRows.length + 1);
        //                }
        //            }
        //        }
        //        return item
        //    })
        //    setTimeSlots(updatedTimeSlots);
        //}
        document.getElementById(id).value = (hour < 10 ? "0" + hour : hour) + ":" + (minutes < 10 ? "0" + minutes : minutes);

    }

    const addNewTimeSlotCopy = (selectTimeSlot, parentIndex) => {

        let slotDuration = +reduxEventDetail.event.EventDuration; // slot duration
        const findParentObj = timeSlots[parentIndex].duplicateTimeSlots; // parent duplicate object

        if (findParentObj.length > 0) {
            const startDate = findParentObj[findParentObj.length - 1].endTime;
            const endDate = new Date(startDate);
            endDate.setMinutes(endDate.getMinutes() + slotDuration);

            const addNewTimeSlotRow = {
                day: selectTimeSlot.day,
                startTime: startDate,
                endTime: endDate,
                isPlusIcon: true,
                isOkButtonVisible: false,
                error: ""
            }

            const updateTimeSlots = timeSlots.map((item) => {
                if (item.day == selectTimeSlot.day) {
                    return { ...item, duplicateTimeSlots: [...item.duplicateTimeSlots, addNewTimeSlotRow] }
                }
                return item;
            })
            setTimeSlots(updateTimeSlots);
            return;
        }

        let startDate = selectTimeSlot.endTimes[selectTimeSlot.endTimes.length - 1].date;
        let endDate = new Date(selectTimeSlot.endTimes[selectTimeSlot.endTimes.length - 1].date);
        endDate.setMinutes(endDate.getMinutes() + slotDuration);

        const addNewTimeSlotRow = {
            day: selectTimeSlot.day,
            startTime: startDate,
            endTime: endDate,
            isPlusIcon: true,
            isOkButtonVisible: false
        }

        const updateTimeSlots = timeSlots.map((item) => {
            if (item.day == selectTimeSlot.day) {
                return { ...item, duplicateTimeSlots: [...item.duplicateTimeSlots, addNewTimeSlotRow] }
            }
            return item;
        })
        setTimeSlots(updateTimeSlots);
        //console.log(updateTimeSlots);
    }

    const addNewDuplicateSlotDurationRow = (selectTimeSlot, parentIndex, subIndex) => {
        let slotDuration = +reduxEventDetail.event.EventDuration; // slot duration

        const findParentObj = timeSlots[parentIndex].duplicateTimeSlots; //

        const startDate = findParentObj[findParentObj.length - 1].endTime;
        const endDate = new Date(startDate);
        endDate.setMinutes(endDate.getMinutes() + slotDuration);

        const addNewTimeSlotRow = {
            day: selectTimeSlot.day,
            startTime: startDate,
            endTime: endDate,
            isPlusIcon: false,
            isOkButtonVisible: false,
            error: ""
        }

        const updateTimeSlots = timeSlots.map((item) => {
            if (item.day == selectTimeSlot.day) {
                return { ...item, duplicateTimeSlots: [...item.duplicateTimeSlots, addNewTimeSlotRow] }
            }
            return item;
        })
        setTimeSlots(updateTimeSlots);
        //console.log(updateTimeSlots);

    }

    const setStartTimeSubDuplicateTimeSlot = (val, subItemObj, subIndex) => {
        //console.log(subItemObj);
        let slotDuration = +reduxEventDetail.event.EventDuration; // slot duration
        let value = dayjs(val).format("HH:mm");
        let [hours, minutes] = value.split(":").map(Number);
        setTimeSlotValidationMessage("");

        let startDate = new Date(subItemObj.startTime);
        startDate.setHours(hours, minutes, 0, 0);

        let endDate = new Date(startDate);
        endDate.setMinutes(endDate.getMinutes() + slotDuration);

        const updateSubDuplicateTimeSlots = timeSlots.map((item) => {
            if (item.day == subItemObj.day && item.isChecked) {
                return {
                    ...item,
                    duplicateTimeSlots: item.duplicateTimeSlots.map((slot, index) => {
                        if (index == subIndex) {
                            return { ...slot, startTime: new Date(startDate), endTime: new Date(endDate) };
                        }
                        return slot;
                    })
                };
            }
            return item;
        })
        setTimeSlots(updateSubDuplicateTimeSlots);
    }

    const onChangeEndTimeSubDuplicateTimeSlot = (val, subItemObj, subIndex) => {
        //let slotDuration = +reduxEventDetail.event.EventDuration; // slot duration
        let value = dayjs(val).format("HH:mm");
        let [hours, minutes] = value.split(":").map(Number);
        setTimeSlotValidationMessage("");

        let endDate = new Date(subItemObj.startTime);
        endDate.setHours(hours, minutes, 0, 0);

        const updateSubDuplicateTimeSlots = timeSlots.map((item) => {
            if (item.day == subItemObj.day && item.isChecked) {
                return {
                    ...item,
                    duplicateTimeSlots: item.duplicateTimeSlots.map((slot, index) => {
                        if (index == subIndex) {
                            return { ...slot, endTime: new Date(endDate), isOkButtonVisible: true, error: "" };
                        }
                        return slot;
                    })
                };
            }
            return item;
        })
        setTimeSlots(updateSubDuplicateTimeSlots);
    }

    const generateSubDuplicateTimeSlots = (subItemObj, parentIndex, subIndex) => {
        let slotDuration = +reduxEventDetail.event.EventDuration;

        const findParentObj = timeSlots[parentIndex].duplicateTimeSlots;
        const lastIndexSubDuplicateTimeSlot = findParentObj[subIndex]//[findParentObj.length - 1];

        let startDate = new Date(lastIndexSubDuplicateTimeSlot.startTime);
        let endDate = new Date(lastIndexSubDuplicateTimeSlot.endTime);

        if (startDate > endDate || startDate == endDate) {

            let updateTimeSlots = timeSlots.map((slots, index) => {
                if (index == parentIndex) {
                    return {
                        ...slots,
                        duplicateTimeSlots: slots.duplicateTimeSlots.map((subSlot, index) => {
                            if (index == subIndex) {
                                return { ...subSlot, error: "wrongDate" }
                            }
                            return subSlot;
                        })
                    }
                }
                return slots;
            });
            //console.log(updateTimeSlots);
            setTimeSlots(updateTimeSlots);
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrMessageEventEndTimeIncr"] : "Event end time should be greater than start time");
            return;
        }

        let subTimeSlots = [];
        let start = new Date(startDate).getTime();   // convert to milliseconds
        let end = new Date(endDate).getTime();
        let step = slotDuration * 60 * 1000;      // duration in ms

        for (let i = start; i < end; i += step) {
            subTimeSlots.push({
                day: subItemObj.day,
                startTime: new Date(i), //.toISOString()
                endTime: new Date(Math.min(i + step, end)), //.toISOString()
                isPlusIcon: subTimeSlots.length == 0 ? true : false,
                isOkButtonVisible: false,
                error: ""
            });
        }

        const updateSubDuplicateTimeSlots = timeSlots.map((item) => {
            if (item.day == subItemObj.day && item.isChecked) {
                return {
                    ...item,                    // slice(0, subIndex); remove select time slot 
                    duplicateTimeSlots: item.duplicateTimeSlots.slice(0, subIndex).concat(subTimeSlots)
                };
            }
            return item;
        });

        setTimeSlots(updateSubDuplicateTimeSlots);
        //console.log(updateSubDuplicateTimeSlots);
    }

    const deleteDuplicateSubTimeSlot = (subItemObj, parentIndex, subIndex) => {
        const findParentObj = timeSlots[parentIndex].duplicateTimeSlots; // find select parent object
        const removeSelectedDuplicateSubTimeSlot = findParentObj.filter((item, index) => index != subIndex); // remove sub duplicate time slot

        const updateSubDuplicateTimeSlots = timeSlots.map((item) => {
            if (item.day == subItemObj.day && item.isChecked) {
                return {
                    ...item,
                    duplicateTimeSlots: removeSelectedDuplicateSubTimeSlot
                };
            }
            return item;
        });

        //console.log(updateSubDuplicateTimeSlots);
        setTimeSlots(updateSubDuplicateTimeSlots);
    }

    const clickHandlerNext = () => {
        let isSelectedFieldsEmpty = false;
        let eventsStartDates = [];
        let eventsEndDates = [];
        const repeatDuplicateAvailableHours = [];
        const createDuplicateFreeSlotNo = +reduxScheduleTimeSlotsDetail.duplicateEachSlotDropdown;

        let anySlotChecked = timeSlots.some(item => item.isChecked == true);
        let isAnyOkVisible = timeSlots.some(item => item.isOkButtonVisible == true); //return true if any Ok button is visible
        if (timeSlotValidationMessage != "") {
            return;
        }
        if (isAnyOkVisible) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["clickingOkMessage"] : "Please confirm the updated end time by clicking 'OK' before proceeding.");
            //variable to handle scroll for first error field
            timeSlots.forEach(item => {
                if (item.isChecked && item.isOkButtonVisible) {
                    document.querySelector("#" + item.day + "To1").parentNode.style.borderColor = "red";
                }
            });
            return;
        }
        
        const dayOccurrences = datesListBetweenStartAndEnd.map(date => {
            const day = days[date.getDay()];
            const dates = date.getDate();
            const _month = date.getMonth();
            const _year = date.getFullYear();
            return {
                dayname: day, monthdate: dates, month: _month, year: _year
            };
        });

        // duplicate time slots startTime and endTime push into orginal timeSlots array startTimes & endTimes
        const updateTimeSlot = timeSlots.map((item) => {
            if (item.isChecked) {
                return {
                    ...item,
                    startTimes: [
                        ...item.startTimes,
                        ...item.duplicateTimeSlots.map(dup => ({ date: dup.startTime }))
                    ],
                    endTimes: [
                        ...item.endTimes,
                        ...item.duplicateTimeSlots.map(dup => ({ date: dup.endTime }))
                    ]
                };
            }
            return item;
        });

        //console.log(timeSlots);
        //console.log(updateTimeSlot);

        //timeSlots
        updateTimeSlot.forEach(item => {
            if (item.isChecked) {
                item.durationSlotsRows.forEach(d => {

                    let fromField = document.querySelector("#" + item.day + "From" + d);
                    let toField = document.querySelector("#" + item.day + "To" + d);
                    if (fromField.value == "") {
                        fromField.parentNode.style.borderColor = "red";
                        isSelectedFieldsEmpty = true;
                    }
                    if (toField.value == "") {
                        toField.parentNode.style.borderColor = "red";
                        isSelectedFieldsEmpty = true;
                    }
                })
                item.startTimes.forEach(time => {
                    const day = days[time.date.getDay()];

                    // Add to eventsStartDates
                    if (dayOccurrences.length > 0 && dayOccurrences.length != 1) {
                        dayOccurrences.forEach(occ => {
                            let slotDate = new Date(time.date);
                            if (occ.dayname == day) {
                                slotDate.setFullYear(occ.year, occ.month, occ.monthdate);
                                eventsStartDates.push({ day, date: slotDate });
                            }
                        })
                    }
                    else {
                        eventsStartDates.push({ day, date: time.date });
                    }
                })
                item.endTimes.forEach(time => {
                    const day = days[time.date.getDay()];

                    if (dayOccurrences.length > 0 && dayOccurrences.length != 1) {
                        dayOccurrences.forEach(occ => {
                            let slotDate = new Date(time.date);
                            if (occ.dayname == day) {
                                slotDate.setFullYear(occ.year, occ.month, occ.monthdate);
                                eventsEndDates.push({ day, date: slotDate });
                            }
                        })
                    }
                    else {
                        eventsEndDates.push({ day, date: time.date });
                    }
                })
            }
        })

        if (dateRangePickerState[0].startDate.getTime() == dateRangePickerState[0].endDate.getTime()) {
            setCheckIntervalTimeDateSelect(true);
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["intervalTimeValidText"] : "Please select the interval time date range");
            return;
        }

        if (isSelectedFieldsEmpty == true) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrorMessageSelectField"] : "Please filled the selected fields");
            //alert("please filled the selected fields");
            return;
        }
        if (anySlotChecked == false) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrorMessageChooseSlot"] : "Please choose at least one slot");
            //alert("please filled the selected fields");
            return;
        }

        let slotsToSave = [];

        slotsToSave = eventsStartDates.map((item, i) => {
            let hoursDetail = {};
            hoursDetail.AllDay = false;
            hoursDetail.Day = item.day;
            var date = new Date(item.date)
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            hoursDetail.StartDateTime = date.toISOString();
            return hoursDetail;
        })

        eventsEndDates.forEach((item, i) => {
            if (i <= slotsToSave.length) {
                var date = new Date(item.date)
                date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
                slotsToSave[i].EndDateTime = date.toISOString();
            }
        })

        let filteredSlots = slotsToSave.filter(item => {
            let currentdate = new Date();
            let eventDate = new Date(item.StartDateTime);
            eventDate.setMinutes(eventDate.getMinutes() + eventDate.getTimezoneOffset());

            return eventDate > currentdate
        })
        //console.log(filteredSlots);
        if (bookAbleUnitLbl != "" && bookAbleUnitVal == "") {
            isSelectedFieldsEmpty = true;
        }

        if (isSelectedFieldsEmpty == true) {
            setTimeSlotValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["availableModalValidErrorMessageSelectField"] : "Please filled the selected fields");
            return;
        }

        // create duplicate free slot many time according to select user dropdown
      /*  for (let i = 0; i < createDuplicateFreeSlotNo; i++) {
            filteredSlots.forEach(item => {
                repeatDuplicateAvailableHours.push({ ...item });
            });
        }*/
        let increment = 1;
        let prevDay = "";
        let checkEventStartDateTime = "";

        filteredSlots.forEach(item => {
            // Reset increment if day changes
            if (item.Day !== prevDay || checkEventStartDateTime != new Date(item.StartDateTime)) increment = 1;

            for (let i = 0; i < createDuplicateFreeSlotNo; i++) {
                //increment++;

                const start = new Date(item.StartDateTime);
                const end = new Date(item.EndDateTime);

                // if user account type "SystemIntegrator" then 1 second increament not add in time
                if (userAccountType != variables.UserAccountTypeIdentity) {
                    start.setSeconds(increment); // increment add
                    end.setSeconds(increment); // increment add
                    increment++;
                }

                repeatDuplicateAvailableHours.push({
                    ...item,
                    StartDateTime: start.toISOString(),
                    EndDateTime: end.toISOString()
                });

                checkEventStartDateTime = new Date(item.StartDateTime);
                prevDay = item.Day;
            }

        })

        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: repeatDuplicateAvailableHours,
            selectedDateRange: dateRangePickerState,
            timeSlots: timeSlots,
            invitee: null,
            confirmEventSlot: null
        };

        if (bookAbleUnitVal && bookAbleUnitLbl) {
            let bookAbleUntilObj = {
                label: bookAbleUnitVal != "" ? bookAbleUnitLbl : null,
                value: bookAbleUnitVal != "" ? bookAbleUnitVal : null
            }
            dispatch(setBookAbleUntil(bookAbleUntilObj));
        }

        dispatch(seteventdetail(eventDetail));
        callBackClickHandlerNext();
    }

    const setSlotValidity = (e) => {
        if (e.target.value != "") {
            setValidTill(+e.target.value);
        }
    }

    const onChangeHandleStartDate = (value, context) => {
        setStartingOnDate(value);
    }

    const onChangeHandleEndDate = (value, context) => {
        //let endingDate = value instanceof Date ? value : new Date(value);
        setEndingOnDate(value);
    }

    const handleDateRangeChange = (item) => {
        let updatedRange = item.selection;
        let startDate = new Date(updatedRange.startDate);
        let endDate = new Date(updatedRange.endDate);
        if (updatedRange.startDate == updatedRange.endDate) {
            updatedRange.endDate = new Date(endDate.setHours(23, 59, 59, 999));
        }
        setDateRangePickerState([updatedRange]);
        setStartingOnDate(new Date(updatedRange.startDate));
        setEndingOnDate(new Date(updatedRange.endDate));
    };

    const dateRangeOnClickOkHandler = () => {
        if (!startingOnDate && !endingOnDate) {
            let obj =
            {
                startDate: new Date(),
                endDate: new Date(),
                key: 'selection'
            }
            setDateRangePickerState([obj]);
        }
        setCheckIntervalTimeDateSelect(false);
        setTimeSlotValidationMessage("");
        setShowPicker(previous => !previous);
    }

    const dateRangeOnClickCancelHandler = () => {
        let obj =
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
        setDateRangePickerState([obj]);
        setShowPicker(previous => !previous);
    }

    const moveBack = () => {

        let eventDetail = {
            event: reduxEventDetail.event,
            availableHours: null,
            selectedDateRange: null,
            timeSlots: null,
            invitee: null,
            confirmEventSlot: null
        };

        setBookAbleUnitLbl("");
        setBookAbleUnitVal("");
        dispatch(clearBookAbleUntil());
        dispatch(seteventdetail(eventDetail));
        backButtonClickHandler();
    }

    const closeModal = () => {
        setBookAbleUnitLbl("");
        setBookAbleUnitVal("");
        dispatch(clearBookAbleUntil());
        handleClose();
    }

    useEffect(() => {
        if (startingOnDate && endingOnDate) {
            let startingDate = startingOnDate; //instanceof Date ? startingOnDate : new Date(startingOnDate); // 
            let endingDate = endingOnDate; //instanceof Date ? endingOnDate : new Date(endingOnDate); // 

            // Validate dates
            if (isNaN(startingDate) || isNaN(endingDate)) {
                console.error("Invalid date format for starting or ending date.");
                return;
            }

            let dateList = [];

            // Generate dates between startingDate and endingDate
            while (startingDate <= endingDate) {
                dateList.push(new Date(startingDate)); // Add a copy of the current date
                startingDate.setDate(startingDate.getDate() + 1); // Increment by 1 day
            }
            setDatesListBetweenStartAndEnd(dateList);
        }
    }, [startingOnDate, endingOnDate])

    useEffect(() => {
        let slotArray = [];
        let mondayIndex = 1; // Index of Monday in the days array

        for (let i = 0; i < 7; i++) {
            // Calculate the day index in the original days array, wrapping around using modulo
            let dayIndex = (mondayIndex + i) % 7;
            let currentDay = days[dayIndex]; // Get the day name (Mon, Tue, etc.)

            slotArray.push({
                day: currentDay,
                weekDay: dayIndex, // Weekday index corresponding to the original array
                durationSlotsRows: [1],
                startTimes: [],
                endTimes: [],
                isChecked: false,
                isOkButtonVisible: false,
                duplicateTimeSlots: []
            });
        }
        if (reduxEventDetail && reduxEventDetail.timeSlots == null) {
            setTimeSlots(slotArray);
        }
        if (!reduxBookableUntil) {
            getEstateConfigurationsFromDb();
        }
        else {
            setBookAbleUnitLbl(reduxBookableUntil.label);
            setBookAbleUnitVal(reduxBookableUntil.value);
        }

        // daterangepicker show & hide
        const handleClickOutside = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setShowPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };

    }, []);

    const disabledHours = (selectedTime) => {
        if (!selectedTime) return [];
        const selectedHour = dayjs(selectedTime).hour();
        return Array.from({ length: selectedHour }, (_, i) => i);
        //return Array.from({ length: selectedHour }, (_, i) => i);
    };

    return (
        <>
            <div className="d-flex justify-content-between mb-3">
                <ul className="form-steps">
                    <li className="step-bar"></li>
                    <li className="step-bar active"></li>
                    <li className="step-bar"></li>
                    <li className="step-bar"></li>
                </ul>
                <img src={closeIcon} onClick={closeModal} className="cursor-pointer" />
            </div>
            <div>
                <p className="form-title mb-2">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalTitle"] : "New Event"}</p>
            </div>
            <div className="warning mb-2">
                <img src={warning} className="me-3" />
                <p className="mb-0">
                    {reduxLanguageTranslations ? reduxLanguageTranslations["availableModalFutureEventText"] : "Only future events will be catered."}
                </p>
            </div>
            <div>
                <p className="subtitle mb-1">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalSubTitleAvailableHours"] : "Available Hours"}</p>
                <p className="modal-p-text mb-4">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalSetTimeText"] : "Set the time that people will be  able to schedule these type of meetings with you."}</p>
            </div>
            <div className="date-selected-container d-block">
                <div>
                    <div className='date-range-container mb-3'>
                        {/*<p className="mb-0">*</p>*/}
                        <input
                            className={`form-control text-center select-date-range-picker-field ${checkIntervalTimeDateSelect ? "border-red" : ""}`}
                            type="text"
                            placeholder="Click to select a date range"
                            onFocus={() => setShowPicker(true)}
                            readOnly
                            value={
                                dateRangePickerState[0].startDate.getTime() == dateRangePickerState[0].endDate.getTime()
                                    ?  reduxLanguageTranslations ? reduxLanguageTranslations["availableModalSelectTimeInterval"] : "Please select time interval"
                                    : `${format(dateRangePickerState[0].startDate, 'P', { locale: currentLocale })} - ${format(dateRangePickerState[0].endDate, 'P', { locale: currentLocale })}`
                            }
                        />
                        {showPicker && (
                            <div className="date-range-picker" ref={pickerRef}>
                                <DateRangePicker
                                    onChange={handleDateRangeChange}
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={dateRangePickerState}
                                    direction="horizontal"
                                    locale={currentLocale || enGB}
                                    staticRanges={staticDateRangeLbl}
                                    inputRanges={inputDateRangeLbl}
                                    minDate={new Date()}
                                    preventSnapRefocus={true}
                                />
                                <div className="col-2 d-flex float-end">
                                    <button className="filter-btn border-dark fs-s color-dark w-100 me-2" onClick={dateRangeOnClickCancelHandler}>Cancel</button>
                                    <button className="site-btn fs-s w-100" onClick={dateRangeOnClickOkHandler}>Ok</button>
                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="form-group mb-3 d-none">
                <label className="form-group-label mt-0">Valid Till</label>
                <select className="form-select" onChange={setSlotValidity}>
                    <option value="">Select Duration</option>
                    <option value="1">Current Week</option>
                    <option value="2">2 Week</option>
                    <option value="3">3 Week</option>
                    <option value="4">4 Week</option>
                    <option value="5">5 Week</option>
                    <option value="6">6 Week</option>
                    <option value="7">7 Week</option>
                    <option value="8">8 Week</option>
                    <option value="9">9 Week</option>
                    <option value="10">10 Week</option>
                </select>
            </div>
            {
                timeSlots.length > 0 ? timeSlots.map((item, index) => {

                    let currentDate = new Date();
                    var currentDay = currentDate.getDay();
                    let isFieldDisabled = false;
                    if (item.weekDay < currentDay && (validTill == "" || validTill == 1)) {
                        isFieldDisabled = true;
                    }

                    let dayname = days[currentDay];

                    let _startTime = "";
                    let _endTime = "";
                    if (item.startTimes[0]) {
                        //let startHour = item.startTimes[0].date.getHours();
                        //let startMinutes = item.startTimes[0].date.getMinutes();
                        //_startTime = (startHour < 10 ? "0" + startHour : startHour) + ":" + (startMinutes < 10 ? "0" + startMinutes : startMinutes);
                        _startTime = item.startTimes[0].date;
                    }
                    if (item.endTimes[0]) {
                        //let endHour = item.endTimes[0].date.getHours();
                        //let endMinutes = item.endTimes[0].date.getMinutes();
                        //_endTime = (endHour < 10 ? "0" + endHour : endHour) + ":" + (endMinutes < 10 ? "0" + endMinutes : endMinutes);
                        _endTime = item.endTimes[0].date;
                    }

                    return (
                        <div key={`${item.day}-${index}`}>
                            <div className={`form-check d-flex align-items-center ${item.isChecked == true && index > 0 ? "mt-4" : ""} ${item.isChecked == true && index == 6 ? "mb-4" : ""}`}>
                                <input className="form-check-input available-hours-check me-3 mt-0" type="checkbox" checked={item.isChecked} durationitem={JSON.stringify(item)} id={`${item.day}Checkbox${index}`} onChange={enableSelectedDayTimeSlot} />
                                <label className={`day-lbl form-check-label me-3 ${dayname == item.day ? "text-highlighted" : ""}`} htmlFor={`${item.day}Checkbox${index}`}>
                                    {/*{item.day}*/}
                                    {reduxLanguageTranslations ? reduxLanguageTranslations[item.day] : ""}
                                </label>
                                <TimePicker format="HH:mm" className={`me-3 ${item.isChecked == false ? "hidden" : ""}`}
                                    id={`${item.day}From1`}
                                    onChange={(e) => setStartTime(e, item, `${item.day}From1`)}
                                    cleanable={false}
                                    container={document.body}
                                    value={_startTime}
                                    editable
                                    open={false}
                                />
                                <TimePicker format="HH:mm" className={`me-3 ${item.isChecked == false ? "hidden" : ""}`}
                                    id={`${item.day}To1`}
                                    cleanable={false}
                                    container={document.body}
                                    value={_endTime}
                                    onChange={(val) => onChangeHandlerEndTime(val, item, `${item.day}To1`)}
                                    open={false}
                                    //shouldDisableHour={hour => hour < _endTime.getHours()}
                                    //shouldDisableMinute={minute => minute % _endTime.getMinutes() !== 0}
                                    editable
                                />
                                <button className={`site-btn site-btn-padd ${item.isChecked && item.isOkButtonVisible ? "" : "d-none"}`} onClick={(e) => generateSubSlots(`${item.day}To1`, item)} >Ok</button>

                                <img src={plusBlueIcon} className={`${item.isChecked && item.isOkButtonVisible == false ? "" : "d-none"}`} onClick={addNewSlotDurationRow} durationitem={JSON.stringify(item)} />

                            </div>
                            {
                                item.durationSlotsRows.length > 0 ? item.durationSlotsRows.map((d, i) => {
                                    if (i == 0) {
                                        return (<></>);
                                    }
                                    let startHour = item.startTimes[i].date.getHours();
                                    let startMinutes = item.startTimes[i].date.getMinutes();
                                    let endHour = item.endTimes[i].date.getHours();
                                    let endMinutes = item.endTimes[i].date.getMinutes();

                                    let startTime = item.startTimes[i].date;//(startHour < 10 ? "0" + startHour : startHour) + ":" + (startMinutes < 10 ? "0" + startMinutes : startMinutes);
                                    let endTime = item.endTimes[i].date; //(endHour < 10 ? "0" + endHour : endHour) + ":" + (endMinutes < 10 ? "0" + endMinutes : endMinutes);
                                    return (
                                        <div className={`form-check mt-4 d-flex align-items-center ${i == (item.durationSlotsRows.length - 1) ? "mb-4" : ""} ${item.isChecked == false ? "d-none" : ""}`} key={`${item.day}-${index}-${i}`}>
                                            <input className="form-check-input available-hours-check me-3 mt-0 hidden" type="checkbox" value="" />
                                            <label className="day-lbl form-check-label me-3 hidden" htmlFor={`${item.day}Checkbox${i}`}>
                                                {item.day}
                                            </label>

                                            <TimePicker format="HH:mm" className={`me-3`}
                                                id={`${item.day}From${d}`}
                                                onChange={(e) => setStartTime(e, item, `${item.day}From${d}`)}
                                                cleanable={false}
                                                container={document.body}
                                                value={startTime}
                                                editable
                                                open={false}
                                                disabled
                                            />
                                            <TimePicker format="HH:mm" className={`me-3`}
                                                id={`${item.day}To${d}`}
                                                cleanable={false}
                                                container={document.body}
                                                value={endTime}
                                                disabled
                                            />
                                            <img src={trashIcon} onClick={deleteSlotRow} durationitem={JSON.stringify(item)} rownumber={d} />
                                        </div>
                                    )
                                })
                                    :
                                    <></>
                            }
                            {
                                item.duplicateTimeSlots.length > 0 ?
                                    item.duplicateTimeSlots.map((subItem, subIndex) => {
                                        return (
                                            <div className={`${item.isChecked == false ? "d-none" : "d-flex mb-3"} ${item.durationSlotsRows.length == 1 ? "mt-3" : "text"}`}>
                                                <input className="form-check-input available-hours-check me-3 mt-0 hidden" type="checkbox" value="" />
                                                <label className="day-lbl form-check-label me-3 hidden" htmlFor={`${item.day}Checkbox${subIndex}`}>
                                                    {item.day}
                                                </label>
                                                <TimePicker format="HH:mm"
                                                    className={`me-3`}
                                                    id={`${subItem.day}From${subIndex}`}
                                                    cleanable={false}
                                                    open={false}
                                                    container={document.body}
                                                    value={subItem.startTime}
                                                    editable={subItem.isPlusIcon}
                                                    disabled={subItem.isPlusIcon !== true}
                                                    onChange={(e) => setStartTimeSubDuplicateTimeSlot(e, subItem, subIndex)}
                                                />
                                                <TimePicker format="HH:mm"
                                                    className={`me-3 ${subItem.error == "wrongDate" ? "availHr-slot-br-red" : "" }`}
                                                    id={`${item.day}To${subIndex}`}
                                                    cleanable={false}
                                                    open={false}
                                                    container={document.body}
                                                    value={subItem.endTime}
                                                    editable={subItem.isPlusIcon}
                                                    disabled={subItem.isPlusIcon !== true}
                                                    onChange={(e) => onChangeEndTimeSubDuplicateTimeSlot(e, subItem, subIndex) }
                                                />
                                                {
                                                    subItem.isPlusIcon ?
                                                        subItem.isOkButtonVisible ?
                                                            <button className={`site-btn site-btn-padd`} onClick={() => generateSubDuplicateTimeSlots(subItem, index, subIndex)}>Ok</button>
                                                            :
                                                            <img src={plusBlueIcon} onClick={() => addNewDuplicateSlotDurationRow(subItem, index, subIndex)} />
                                                        :
                                                        <img src={trashIcon} onClick={() => deleteDuplicateSubTimeSlot(subItem, index, subIndex) } />
                                                }
                                            </div>
                                        )
                                    })
                                    :
                                    <></>

                            }
                            <div className={`${item.isChecked == false ? "d-none" : "d-flex pt-2"}`}>
                                <input className="form-check-input available-hours-check mt-0 hidden" type="checkbox" value="" />
                                <label className="day-lbl form-check-label me-3 hidden" htmlFor={`${item.day}Checkbox${index}`}>
                                    {item.day}
                                </label>

                                <span className="specifceDateAddNewDate-container" onClick={item.startTimes.length > 0 ? () => addNewTimeSlotCopy(item, index) : undefined}>
                                    <img src={plusBlueIcon} className="me-2" />
                                    <span className="duplicate-SpecificDate-addNewSlotBtnText">{reduxLanguageTranslations ? reduxLanguageTranslations["addNewTimeSlotBtnTxt"] : "Add new time slot"}</span>
                                </span>
                            </div>
                        </div>
                    )
                })
                    :
                    <></>
            }

            {/* <div className="d-flex justify-content-between align-items-center">
                <p className="subtitle mb-1 w-50">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBookAbleUnitText"] : "Bookable until:"}</p>
                <div className="d-flex justify-content-between align-items-center">
                    <input className={`form-control no-spinner me-2 ${bookAbleUnitLbl != "" && bookAbleUnitLbl != null ? "d-blcok" : "d-none"} `} type="number" value={bookAbleUnitVal} onChange={handlerBookAbleUnitVal} />
                    <select className="form-select" value={bookAbleUnitLbl} onChange={handlerBookAbleUnitSelectLbl}>
                        <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select Option"}</option>
                        <option value="days">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBookAbleUnitDaysOpt"] : "Days"}</option>
                        <option value="hours">{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBookAbleUnitHoursOpt"] : "Hours"}</option>
                    </select>
                </div>
            </div> */}

            <div className={`${timeSlotValidationMessage == "" ? "d-none" : "mt-4 mb-3"}`}>
                <p className={`text-red fs-small login-field-error`}>{timeSlotValidationMessage}</p>
            </div>
            <div className="d-flex mt-4">
                <button type="button" className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" onClick={moveBack}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalBackBtn"] : "Back"}</button>
                <button type="button" className="site-btn site-btn-padd w-100" onClick={clickHandlerNext}>{reduxLanguageTranslations ? reduxLanguageTranslations["availableModalNextBtn"] : "Next"}</button>
            </div>
        </>
    )
}